<template>
  <div class="string-list">
    <ul
      v-if="values.length"
    >
      <li class="string-list__element">
        {{ heading }}
      </li>
      <li
        v-for="(value, index) in values"
        :key="index"
        class="string-list__element"
      >
        {{ value }}
      </li>
    </ul>
  </div>
</template>
<script>

const StringList = {
  name: 'string-list',
  props: {
    heading: String,
    values: Array,
  }
}

export default StringList
</script>
